<div class="wrap">
    <ngx-spinner bdColor="rgba(0, 0, 0, 0.45)" size="medium" color="#fff" type="ball-scale-multiple" [fullScreen]="true">
        <p style="color: #fff">Generating report...</p>
    </ngx-spinner>
    <app-header></app-header>
    <div class="main-holder">
        <app-nav></app-nav>
        <div class="main">
            <div class="main-content">
                <div class="bread">
                    <ol>
                        <li><a [routerLink]="['/']"><img src="../../../../assets/okito/images/icons/home.svg"></a></li>
                        <img src="../../../../assets/okito/images/icons/chevron-right.svg">
                        <li><span>Partners</span></li>
                    </ol>
                </div>
                <div class="partners-head">
                    <div class="content-title">
                        <h2>Partners</h2>
                    </div>
                    <div class="partners-head-actions">
                        <label for="asOf">As of</label>
                        <div class="calendar">
                            <input type="date" id="asOf" class="text-calendar"
                                   [(ngModel)]="asOf" (ngModelChange)="onAsOfChange()">
                            <img src="../../../../assets/okito/images/calendar.svg">
                        </div>
                    </div>
                </div>
                <hr>
                <div class="list-tabs">
                    <ul>
                        <li class="active"><a [routerLink]="['/admin/riders']">Partner List</a></li>
                        <li><a [routerLink]="['/admin/partners-summary']">Summary</a></li>
                    </ul>
                </div>
                <div class="partner-api-notice" *ngIf="apiMissingFilters || apiMissingCounts">
                    <i class="fa fa-exclamation-circle"></i>
                    <span>
                        This environment's API doesn't have the Partners
                        <ng-container *ngIf="apiMissingFilters">vehicle and service filters</ng-container>
                        <ng-container *ngIf="apiMissingFilters && apiMissingCounts"> or the </ng-container>
                        <ng-container *ngIf="apiMissingCounts">status tab counts</ng-container>
                        yet. The partner list below is unaffected.
                    </span>
                </div>
                <div class="list-holder">
                    <div class="partner-filters">
                        <div class="partner-filter partner-filter-search">
                            <div class="search">
                                <img src="../../../../assets/okito/images/icons/magnifying.svg">
                                <input (input)="searchData($event)" [(ngModel)]="this.searchKeyword" type="text"
                                       id="partnerSearch" aria-label="Search partners" class="text-search"
                                       placeholder="Name, partner ID, plate number">
                            </div>
                        </div>
                        <div class="partner-filter">
                            <select id="partnerVehicle" aria-label="Filter by vehicle" class="sort-select"
                                    [disabled]="apiMissingFilters"
                                    [(ngModel)]="vehicleFilter" (ngModelChange)="onFilterChange()">
                                <option value="">All vehicles</option>
                                <option value="TWO_WHEEL">2-Wheel</option>
                                <option value="FOUR_WHEEL">4-Wheel</option>
                                <option value="TRUCK">Truck</option>
                            </select>
                        </div>
                        <div class="partner-filter">
                            <select id="partnerService" aria-label="Filter by service" class="sort-select"
                                    [disabled]="apiMissingFilters"
                                    [(ngModel)]="serviceFilter" (ngModelChange)="onFilterChange()">
                                <option value="">All services</option>
                                <option value="EXPRESS_TWO_WHEEL">Motor Express</option>
                                <option value="MOTOTAXI">MotoTaxi</option>
                                <option value="TNVS">TNVS</option>
                                <option value="TAXI">Taxi</option>
                                <option value="EXPRESS_FOUR_WHEEL">4-Wheel Express</option>
                                <option value="TRUCK">Trucks</option>
                            </select>
                        </div>
                        <div class="partner-filter">
                            <select id="partnerSort" aria-label="Sort order" class="sort-select"
                                    [(ngModel)]="sortChoice" (ngModelChange)="onSortChange()">
                                <option value="dateCreated:desc">Date created · newest</option>
                                <option value="dateCreated:asc">Date created · oldest</option>
                                <option value="dateApprove:desc">Date approved</option>
                                <option value="lastName:asc">Name · A to Z</option>
                            </select>
                        </div>
                        <button class="btn btn-sm btn-default" (click)="openPartnerReportModal(partnerReportModal)">Download</button>
                    </div>
                    <div class="list-tabs">
                        <ul>
                            <li *ngFor="let tab of statusTabs" [ngClass]="{'active': partnerTabs[tab.key]}">
                                <a (click)="filterUser(tab.key)" style="cursor: pointer;">
                                    {{ tab.label }}
                                    <span class="tab-count" *ngIf="pipelineLoaded">{{ tabCount(tab.key) | number }}</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div class="list table-responsive partners-list">
                        <table>
                            <thead>
                                <tr>
                                    <th>Partner ID</th>
                                    <th>Name</th>
                                    <th>Vehicle</th>
                                    <th>Approved Services</th>
                                    <th>Date Approved</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <ng-container *ngIf="this.isLoadingList; else loadedList">
                                    <tr *ngFor="let skeletonRow of [1,2,3,4,5,6]" class="skeleton-row">
                                        <td *ngFor="let skeletonCell of [1,2,3,4,5,6,7]"><div class="skeleton-block"></div></td>
                                    </tr>
                                </ng-container>
                                <ng-template #loadedList>
                                <ng-container *ngIf="currentSelectedPageList.length != 0; else noRecords">
                                    <tr *ngFor="let rider of this.currentSelectedPageList">
                                        <td>{{ rider.membershipId }}</td>
                                        <td><strong>{{ fullName(rider) }}</strong></td>
                                        <td>{{ vehicleLabel(rider) }}</td>
                                        <td>
                                            <span class="svc-tags" *ngIf="serviceTags(rider).length; else noServices">
                                                <span class="svc-tag" *ngFor="let tag of serviceTags(rider)"
                                                      [ngClass]="tag.className">{{ tag.label }}</span>
                                            </span>
                                            <ng-template #noServices>&mdash;</ng-template>
                                        </td>
                                        <td>{{ approvedOn(rider) }}</td>
                                        <td>
                                            <span class="stat" [ngClass]="statusClass(rider.status)">{{ statusLabel(rider.status) }}</span>
                                        </td>
                                        <td>
                                            <!-- Manual top-up is not in the new design but is a live admin
                                                 capability, so it stays beside View. -->
                                            <a *ngIf="rider.status == 'approved'" (click)="manualTopUp(rider.partnerId, topupForm)"
                                               style="cursor: pointer; margin-right: 12px;">Top Up</a>
                                            <a (click)="viewDetails(rider)" style="cursor: pointer;">View</a>
                                        </td>
                                    </tr>
                                </ng-container>
                                <ng-template #noRecords>
                                    <tr>
                                        <td colspan="7" class="no-records-msg">
                                            <h6 class="ponds-contents-med-bold">No records found</h6>
                                        </td>
                                    </tr>
                                </ng-template>
                                </ng-template>
                            </tbody>
                        </table>
                    </div>
                    <div class="list-footer" *ngIf="this.riderList.length != 0">
                        <div class="pager">
                            <button (click)="nextPrev('prev')" [disabled]="this.currentPage <= 1" class="pager-prev"><img
                                    src="../../../../assets/okito/images/icons/prev.svg"></button>

                            <button (click)="nextPrev('next')" [disabled]="this.disableActionBtns.next" class="pager-next"><img
                                    src="../../../../assets/okito/images/icons/next.svg"></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <ng-template #partnerReportModal let-modal>
        <div class="modal-header">
            <h5 class="modal-title">Download Partner Report</h5>
            <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
        </div>
        <div class="modal-body">
            <div class="modal-form">
                <div class="form-item">
                    <label class="form-label">Report Start Date</label>
                    <input type="date" class="form-control" [(ngModel)]="partnerReportDate">
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <button type="button" class="btn btn-outline btn-full" [disabled]="isDownloadingReport" (click)="downloadPartnerReport('template_1')">
                            <i *ngIf="isDownloadingReport" class="fa fa-spinner fa-spin"></i>
                            Template 1
                        </button>
                    </div>
                    <div class="col-md-6">
                        <button type="button" class="btn btn-outline btn-full" [disabled]="isDownloadingReport" (click)="downloadPartnerReport('template_2')">
                            <i *ngIf="isDownloadingReport" class="fa fa-spinner fa-spin"></i>
                            Template 2
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>

    <!-- Topup Modals -->
    <ng-template #topupForm let-modal class="modal">
        <div class="modal-header">
            <h5 class="modal-title" id="staticBackdropLabel">Partner Topup (Manual)</h5>
        </div>
        <div class="modal-body">
            <div class="modal-form">
                <div class="form-item">
                    <label class="form-label">Amount to Top Up</label>
                    <input type="text" class="form-control" placeholder="Enter title" [(ngModel)]="topUpForm['amt']">
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-outline" (click)="modal.dismiss('Cross click')">Cancel</button>
            <button type="button" class="btn btn-default" (click)="confirmManualTopUp(confirmTopup)">Top up</button>
        </div>
    </ng-template>

    <ng-template #confirmTopup let-modal id="photo" class="modal">
        <div class="modal-body">
            <p>Are you sure you want to proceed the topup for this partner?</p>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-outline" (click)="modal.dismiss('Cross click')">No, Cancel it</button>
            <button type="button" class="btn btn-default" (click)="processTopUp(sucesssTopUp)">Yes, Proceed</button>
        </div>
    </ng-template>

    <ng-template #sucesssTopUp let-modal id="photo" class="modal">
        <div class="modal-body success-body">
            <img src="../../../../assets/okito/images/modal-success.svg">
            <p>Topup success</p>
            <button class="btn btn-default" (click)="closeAllModals()">Close</button>
        </div>
    </ng-template>

</div>
